import { render, staticRenderFns } from "./VeJwCjBukaoModal.vue?vue&type=template&id=797000a0"
import script from "./VeJwCjBukaoModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjBukaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports